<div class="login-form">
  <mat-card>
    <mat-card-content>

      <mat-card-title>
        <h2>Sign up</h2>
      </mat-card-title>

      <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput placeholder="email@example.com" formControlName="email" type="email" required>
          <mat-hint>Use your account email</mat-hint>
          <mat-icon matSuffix>email</mat-icon>
          @if (email?.invalid && email?.touched) {
          <mat-error>{{getEmailErrorMessage()}}</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Username</mat-label>
          <input matInput placeholder="username" formControlName="username" required>
          <mat-hint>Create new username</mat-hint>
          <mat-icon matSuffix>person_add_alt</mat-icon>
          @if (username?.invalid && username?.touched) {
          <mat-error>{{getUsernameErrorMessage()}}</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Create Password</mat-label>
          <input matInput [type]="hideNewPass ? 'password' : 'text'" formControlName="password" required minlength="8">
          <button type="button" mat-icon-button matSuffix (click)="hideNewPass = !hideNewPass"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNewPass">
            <mat-icon>{{hideNewPass ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          @if (password?.invalid && password?.touched) {
          <mat-error>{{getPasswordErrorMessage()}}</mat-error>
          }
          <mat-hint>Letters, numbers, symbols allowed (min 8 characters)</mat-hint>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Confirm Password</mat-label>
          <input matInput [type]="hideConfirmPass ? 'password' : 'text'" formControlName="confirmPassword" required>
          <button type="button" mat-icon-button matSuffix (click)="hideConfirmPass = !hideConfirmPass"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPass">
            <mat-icon [color]="doPasswordsMatch() ? 'primary' : 'warn'">
              {{doPasswordsMatch() ? 'lock' : 'lock_open'}}
            </mat-icon>
          </button>
          @if (confirmPassword?.invalid && confirmPassword?.touched || signupForm.hasError('passwordMismatch') &&
          confirmPassword?.touched) {
          <mat-error>{{getConfirmPasswordErrorMessage()}}</mat-error>
          }
          <mat-hint>Repeat the same password</mat-hint>
        </mat-form-field>

        <mat-card-actions>
          <button mat-raised-button color="accent" type="submit">Sign up</button>
        </mat-card-actions>

      </form>

      <p>Have an account? <a routerLink="/login" routerLinkActive="active" ariaCurrentWhenActive="page">Login</a></p>

    </mat-card-content>
  </mat-card>
</div>